import { createColorVariable as r, createOutline as o } from "./highrise530.mjs";
function t(e) {
  return {
    color: "transparent",
    border: "none",
    textColor: r(e, 700),
    rippleColor: r(e, 600),
    // hover
    borderHover: "none",
    colorHover: "transparent",
    textColorHover: r(e, 800),
    // focus
    colorFocus: "transparent",
    borderFocus: "none",
    textColorFocus: r(e, 800),
    outlineFocus: o(e, 100),
    // pressed
    borderPressed: "none",
    colorPressed: "transparent",
    textColorPressed: r(e, 900),
    // disabled
    borderDisabled: "none",
    colorDisabled: "transparent",
    textColorDisabled: r(e, 300)
  };
}
export {
  t as createTextTheme
};
